import filterNav from '../../../modifiers/filterNav'
import links from '../../../links'
import constants from '../../../constants'
import getNotEmptyCosmeticsCategories from '../../getNotEmptyCosmeticsCategories'

import messages from './messages'


const { skincare: { categories: skincareCategories } } = constants.cosmeticsCategories
const { skincare: skincareTypes } = constants.cosmeticsProductTypes

const getSkincareTypes = (values) => {
  const { notEmptyTypes, withoutAll } = values

  const categories = [
    (
      !withoutAll && (
        { name: skincareCategories.all, title: messages.all, to: links.skincare }
      )
    ),
    ...(
      getNotEmptyCosmeticsCategories({
        root: constants.cosmeticsCategories.skincare.name,
        types: notEmptyTypes,
        categories: [
          {
            name: skincareCategories.lip,
            title: messages.lip,
            to: links.skincareLip,
            subCategories: [
              {
                name: skincareTypes.lip.lipBalm,
                title: messages.lipBalm,
                to: `${links.skincareLip}?type=${skincareTypes.lip.lipBalm}`,
              },
            ],
          },
          {
            name: skincareCategories.eye,
            title: messages.eye,
            to: links.skincareEye,
            subCategories: [
              {
                name: skincareTypes.eye.eyeMasks,
                title: messages.eyeMasks,
                to: `${links.skincareEye}?type=${skincareTypes.eye.eyeMasks}`,
              },
              {
                name: skincareTypes.eye.eyeCreamsTreatments,
                title: messages.eyeCreamsTreatments,
                to: `${links.skincareEye}?type=${skincareTypes.eye.eyeCreamsTreatments}`,
              },
            ],
          },
          {
            name: skincareCategories.mens,
            title: messages.mens,
            to: links.skincareMens,
            subCategories: [
              {
                name: skincareTypes.mens.face,
                title: messages.menFace,
                to: `${links.skincareMens}?type=${skincareTypes.mens.face}`,
              },
              {
                name: skincareTypes.mens.eye,
                title: messages.menEye,
                to: `${links.skincareMens}?type=${skincareTypes.mens.eye}`,
              },
              {
                name: skincareTypes.mens.shaving,
                title: messages.menShaving,
                to: `${links.skincareMens}?type=${skincareTypes.mens.shaving}`,
              },
            ],
          },
          {
            name: skincareCategories.cleansers,
            title: messages.cleansers,
            to: links.skincareCleansers,
            subCategories: [
              {
                name: skincareTypes.cleansers.faceWipes,
                title: messages.faceWipes,
                to: `${links.skincareCleansers}?type=${skincareTypes.cleansers.faceWipes}`,
              },
              {
                name: skincareTypes.cleansers.faceWash,
                title: messages.faceWash,
                to: `${links.skincareCleansers}?type=${skincareTypes.cleansers.faceWash}`,
              },
              {
                name: skincareTypes.cleansers.exfoliators,
                title: messages.exfoliators,
                to: `${links.skincareCleansers}?type=${skincareTypes.cleansers.exfoliators}`,
              },
              {
                name: skincareTypes.cleansers.toner,
                title: messages.toner,
                to: `${links.skincareCleansers}?type=${skincareTypes.cleansers.toner}`,
              },
              {
                name: skincareTypes.cleansers.makeupRemover,
                title: messages.makeupRemover,
                to: `${links.skincareCleansers}?type=${skincareTypes.cleansers.makeupRemover}`,
              },
            ],
          },
          {
            name: skincareCategories.masks,
            title: messages.masks,
            to: links.skincareMasks,
            subCategories: [
              {
                name: skincareTypes.masks.faceMask,
                title: messages.faceMask,
                to: `${links.skincareMasks}?type=${skincareTypes.masks.faceMask}`,
              },
              {
                name: skincareTypes.masks.sheetMask,
                title: messages.sheetMask,
                to: `${links.skincareMasks}?type=${skincareTypes.masks.sheetMask}`,
              },
            ],
          },
          {
            name: skincareCategories.moisturizers,
            title: messages.moisturizers,
            to: links.skincareMoisturizers,
            subCategories: [
              {
                name: skincareTypes.moisturizers.mists,
                title: messages.mists,
                to: `${links.skincareMoisturizers}?type=${skincareTypes.moisturizers.mists}`,
              },
              {
                name: skincareTypes.moisturizers.faceOil,
                title: messages.faceOil,
                to: `${links.skincareMoisturizers}?type=${skincareTypes.moisturizers.faceOil}`,
              },
              {
                name: skincareTypes.moisturizers.faceMoisturizer,
                title: messages.faceMoisturizer,
                to: `${links.skincareMoisturizers}?type=${skincareTypes.moisturizers.faceMoisturizer}`,
              },
            ],
          },
          {
            name: skincareCategories.treatments,
            title: messages.treatments,
            to: links.skincareTreatments,
            subCategories: [
              {
                name: skincareTypes.treatments.serum,
                title: messages.serum,
                to: `${links.skincareTreatments}?type=${skincareTypes.treatments.serum}`,
              },
              {
                name: skincareTypes.treatments.ampoules,
                title: messages.ampoules,
                to: `${links.skincareTreatments}?type=${skincareTypes.treatments.ampoules}`,
              },
              {
                name: skincareTypes.treatments.blemishAcneSolutions,
                title: messages.blemishAcneSolutions,
                to: `${links.skincareTreatments}?type=${skincareTypes.treatments.blemishAcneSolutions}`,
              },
            ],
          },
          {
            name: skincareCategories.wellness,
            title: messages.wellness,
            to: links.skincareWellness,
            subCategories: [
              {
                name: skincareTypes.wellness.calmSootheSleep,
                title: messages.calmSootheSleep,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.calmSootheSleep}`,
              },
              {
                name: skincareTypes.wellness.energyUpgrade,
                title: messages.energyUpgrade,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.energyUpgrade}`,
              },
              {
                name: skincareTypes.wellness.gutHealth,
                title: messages.gutHealth,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.gutHealth}`,
              },
              {
                name: skincareTypes.wellness.hairSkinNail,
                title: messages.hairSkinNail,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.hairSkinNail}`,
              },
              {
                name: skincareTypes.wellness.immuneSupport,
                title: messages.immuneSupport,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.immuneSupport}`,
              },
              {
                name: skincareTypes.wellness.womensHealth,
                title: messages.womensHealth,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.womensHealth}`,
              },
              {
                name: skincareTypes.wellness.workout,
                title: messages.workout,
                to: `${links.skincareWellness}?type=${skincareTypes.wellness.workout}`,
              },
            ],
          },
        ],
      })
    ),
  ]

  // Remove "false" elements [ {..}, false, {..} ] -> [ {..}, {..} ]
  const filteredCategories = categories
    .filter((category) => Boolean(category))
    .map((category) => {
      const { subCategories } = category

      if (Boolean(subCategories)) {
        category.subCategories = subCategories.filter((subCategory) => Boolean(subCategory))
      }

      return category
    })

  return filterNav(filteredCategories, 'subCategories')
}


export default getSkincareTypes
